import { useQuery } from '@hooks/reactQuery';

import { getPortalTasksToLink } from '@api/portalTasks';

import { extractQueryParams } from '@utils/common';
import { portalTasksToLinkFormatted } from '@utils/formatter';

import { IPortalTaskToLinkDTO } from '@interfaces/portal/dto/taskManagementDTO';

import { refetchOptions } from '@constants/common';
import { GET_PORTAL_TASKS_TO_LINK } from '@constants/queryKeys';

interface IUseQueryPortalTasksToLinkReturned {
	isLoadingPortalTasksToLink: boolean;
	portalTasksToLink: IPortalTaskToLinkDTO[];
}

interface IUseQueryPortalTasksToLink {
	taskId?: string | null;
	projectId?: string;
}

export const useQueryPortalTasksToLink = ({
	taskId,
	projectId,
}: IUseQueryPortalTasksToLink): IUseQueryPortalTasksToLinkReturned => {
	const {
		data,
		isLoading,
		isFetching,
	} = useQuery<IPortalTaskToLinkDTO[]>({
			queryKey: [
				GET_PORTAL_TASKS_TO_LINK,
				{
					taskId,
					projectId,
				},
			],
			queryFn: extractQueryParams(getPortalTasksToLink),
			select: tasks => portalTasksToLinkFormatted(tasks),
			enabled: [!!projectId],
			...refetchOptions,
		},
	);

	return {
		isLoadingPortalTasksToLink: isLoading || isFetching,
		portalTasksToLink: data || [],
	};
};
